/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Hidrostatica() {
  return (
    <PaginasEspecificas posicao="11" endereco="/fisica" materia="Física" />
  );
}

export default Hidrostatica;
